import request from '@/axios'

export function createActivity (payload) {
  return request({
    url: '/activity_logs/create',
    method: 'POST',
    data: payload
  })
}

export function getActivityList (payload, next_page_url) {
  let page_url = '/activity_logs/list'

  if (next_page_url) {
    page_url = next_page_url
  }

  return request({
    url: page_url,
    method: 'POST',
    data: payload
  })
}

export function getParticularActivity (payload) {
  return request({
    url: '/activity_logs/show',
    method: 'POST',
    data: payload
  })
}